var context = "portal-list/aru/";
var app = angular.module("app", [
  "ngRoute",
  "ngCookies",
  "ngMessages",
  "app.filters",
  "app.services",
  "pascalprecht.translate",
  "ang-drag-drop",
  "ngStorage",
  "ngInputCurrency",
  "angularFileUpload",
  "ngDraggable",
  "ui.select",
  "app.components",
  "ngSanitize",
  /**
   * Components
   */
  "superSelect.components",
  "ngSinossi.validation-module",
  "progressBar.components",
  "parentLevelOneCarousel.components",
  "mainCarouselMenu.components",
  "formRecoveryPasswordArf.components",
  "topTitleInfo.components",
  "app.directives",
  "overlayModal.components",
  "topTitleInfoSearch.components",
  "selectLanguage.components",
  "advanceCheckbox.components",
  "datepicker.components",
  "inputEmail.components",
  "inputPassword.components",
  "inputContract.components",
  "truncatedPopover.components",
  "inputTel.components",
  "inputName.components",
  "inputPin.components",
  "angularUtils.directives.dirPagination",
  "inputCf.components",
  "inputPiva.components",
  "inputCdDestinatario.components",
  "pdf",
  "accordionPrivacy.components",
  "app.prototypes",
  "goodDescriptionAccordion.components",
  "goodPriceAccordion.components",
  "rangeComponent.componets",
  "additionalDocumentation.components",
  "modeOfRecognition.components",
  "accordionFatturazioneElettronica.components",
  "accordionContractualTransparency.components",
  "qcc.components",
  "autorizzazioneSdd.components",
  "transactionTableDigital.components",
  "searchTableDigital.components",
  "fondiBei.components",
  "newRequest.components",
  "transactionTableDigitalSign.components",
  "filterTableContractSign.components",
  "variazioneTargato.components",
  "requestData.components",
  "variazioneAnagSoc.components",
  "requestDataAnagSoc.components",
  "munAuthorization.components",
  "municipalAuthData.components",
  "contractSelectedTable.components",
  "calcoloIrap.components",
  "dettagliCalcolo.components",
  "autorizzazioneIban.components",
  "nuovoRespUtenza.components",
  "gestioneVerbale.components",

  /*,
  'pdfjsViewer',
    'inputPiva.components'*/
  "genericInput.components",
  "currencyInput.components",
  "accordionAppropriateVerification.components",
  "accordionIndividualPerson.components",
  "naturalPersonCensus.components",
  "footerInstant.components",
  "inputMobile.components",
  "transactionTable.components",
  "accordionUploadDocumentsInstant.components",
  "accordionUploadDocuments.components",
  "accordionDatiCliente.components",
  "personalDocumentsTable.components",
  "sede.components",
  "addressTable.components",
  "accordionIntegrazioneInformazioni.components",
  "invitesTable.components",
  "accordionToBeCorrected.components",
  "tablePagination.components",
  "stepProgressBar.components",
  "accordionUploadDocumentsInstantTemp.components",
  'accordionUploadDocumentsEstero.components',
  "faq.components",
  "faqAccordion.components",
  "uploadPersonalDocument.components",
  "uploadPersonalDocumentDigital.components",
  "uploadPersonalDocumentPv.components",
  "dettaglioContratto.components",
  "dettaglio.components",
  "elencoBeni.components",
  "dettaglioCanone.components",
  "accordionAziendaGarante.components",
  "accordionUpdateAzienda.components",
  "dettaglioCruscottoRichiestaClienti.components",
  "dettaglioCruscottoRichiestaClientiARU.components",
  "dateRequest.components",
  "richiestaCessione.components",
  "datiRichiesta.components",
  "questionarioClientela.components",
  "richiestaVoltura.components",
  "informazioniUtili.components",
  "modalViewDocuments.components",
  "practiceData.components",
  "accordionProrogaMoratoria.components",
  "riscattoTermine.components",
  "accordionUploadDocumentsInstantPostVend.components",
  "ricercaADV.components",
  //Digital Leasing modules
  "digitalLeasing.module",
  "app.containers",
  "accordionDatiClienteDigital.components",
  "accordionDatiCliente.components",
  "accordionFatturazioneElettronica.components",
  "multiSelect.components",
  "searchTableDigital.components",
  "importPercent.components",
  "customerSearch.components",
  "customerDigital.components",
  "questionarioAdv.module",
  "newDatepicker.components",
  //Richiesta PostVendita,
  "genericChecklistDownload.components",
  "genericChecklistUpload.components",
  "otherDocumentation.components",
  "cadastralDocSubscription.components",
  "cadastralDocs.components",
  "delegationRequest.components",
  "cadastralMunicipalDel.components",
  "accordionDelegateInfo.components",
  "accordionUpdateDelegato.components",
  "varCoordBan.components",
  "requestDataCoordBan.components",
  "munAuthorization.components",
  "municipalAuthData.components",
  "contractSelectedTable.components",
  "changeGoodAddress.components",
  "goodInstallationAddress.components",
  "accordionAggiornamentoDocumenti.components",
  "footerPostVendita.componets",
  "newDatepicker.components",
  "historyPractice.components",
  "contractSelectedAddressInfo.components",
  "riscattoAnticipato.components",
  "requestDataAnticipato.components",
  "datiAnagraficiCessionario.components",
  "cambioSocietaControllante.components",
  "genericContacts.components",
  "richiestaLpf.components",
  "preventivoRiscatto.components",
  "firmatarioRiscatto.components",
  "sublocazioneNoleggio.components",
  "informazioniImmobile.components",
  "accordionAggiornamentoAdv.module",
  "avvisoRiscatto.components",
  "sintesiEstinzione.components",
  "modalitaFirmaPostVendita.components",
  "modalDetailsPv.components",
  "newUploadIcon.components",
  "infoOperative.components",
  "showCervedInfosPv.components",
  "contatti.components",
  "coordinateBancarie.components",
  "checkListPostVendita.components",
  "firmatarioRiscattoTermine.components",
  "confermaAccettazione.components",
  'timeoutButton.components',
  'accordionSearchTitolari.components',
  'accordionSearchFiducianti.components',
  'infoLicenzaNoleggio.components',
  'searchPf.components',
  'fondiBeiPv.components',
  'luoghiInstallazionePv.components'
]);

app
  .config(function (
    $locationProvider,
    $routeProvider,
    $translateProvider,
    $compileProvider
  ) {
    $locationProvider.hashPrefix("");

    $routeProvider
      .when("/", {
        templateUrl: context + "route/home/view.html",
        controller: "HomeCtrl",
      })
      .when("/login", {
        templateUrl: context + "route/login/view.html",
        controller: "LoginCtrl",
      })
      .when("/registerVendor", {
        templateUrl: context + "route/registerVendor/view.html",
        controller: "RegisterVendorCtrl",
      })
      .when("/registerCustomer", {
        templateUrl:
          context + "route/registerCustomer/registerCustomer.view.html",
        controller: "RegisterCustomerCtrl",
      })
      .when("/handleContracts", {
        templateUrl: context + "route/handleContracts/view.html",
        controller: "HandleContractsCtrl",
      })
      .when("/contractDetails", {
        templateUrl: context + "route/contractDetails/view.html",
        controller: "ContractDetailsCtrl",
      })
      .when("/instantLeasing", {
        templateUrl: context + "route/instantLeasing/view.html",
        controller: "InstantLeasingCtrl",
      })
      .when("/signedContracts", {
        templateUrl: context + "route/signedContracts/view.html",
        controller: "SignedContractsCtrl",
      })
      .when("/logout", {
        templateUrl: context + "route/logout/logout.html",
        controller: "LogoutCtrl",
      })
      .when("/practiceDetail", {
        templateUrl: context + "route/practiceDetail/view.html",
        controller: "PracticeDetailCtrl",
      })
      .when("/dataCompletition", {
        templateUrl: context + "route/dataCompletition/view.html",
        controller: "DataCompletitionCtrl",
      })
      .when("/toBeCorrected", {
        templateUrl: context + "route/toBeCorrected/view.html",
        controller: "toBeCorrectedCtrl",
      })
      .when("/digitalLeasing", {
        templateUrl: context + "route/digitalLeasing/view.html",
        controller: "digitalLeasingCtrl",
      })
      .when("/faq", {
        templateUrl: context + "route/faq/view.html",
        controller: "FaqCtrl",
      })
      .when("/classificazioneFondiBei", {
        templateUrl: context + "route/classificazioneFondiBei/view.html",
        controller: "ClassificazioneFondiBeiCtrl",
      })
      .when("/mycontracts", {
        templateUrl: context + "route/myContracts/view.html",
        controller: "MyContractsCtrl",
      })
      .when("/docArchive", {
        templateUrl: context + "route/docArchive/view.html",
        controller: "DocArchiveCtrl",
      })
      .when("/dettaglioContratto", {
        templateUrl: context + "route/dettaglioContratto/view.html",
        controller: "dettaglioContrattoCtrl",
      })
      .when("/firmaDigitale", {
        templateUrl: context + "route/firmaDigitale/view.html",
        controller: "FirmaDigitaleCtrl",
      })
      .when("/variazioneTargato", {
        templateUrl: context + "route/varTargato/view.html",
        controller: "VariazioneTargatoCtrl",
      })
      .when("/variazioneAnagSoc", {
        templateUrl: context + "route/varAnagSoc/view.html",
        controller: "VariazioneAnagSocCtrl",
      })
      .when("/dettaglioCruscottoRichiestaClienti", {
        templateUrl:
          context + "route/dettaglioCruscottoRichiestaClienti/view.html",
        controller: "dettaglioCruscottoRichiestaClientiCtrl",
      })
      .when("/municipalAuthorization", {
        templateUrl:
          context + "route/municipalAuthorization/municipalAuthorization.html",
        controller: "munAuthorizationCtrl",
      })
      .when("/cadastralDocSubscr", {
        templateUrl:
          context + "route/cadastralDocumentation/cadastralDocumentation.html",
        controller: "cadDocSubscrCtrl",
      })
      .when("/richiestaCessione", {
        templateUrl: context + "route/richiestaCessione/view.html",
        controller: "richiestaCessioneCtrl",
      })
      .when("/richiestaVoltura", {
        templateUrl: context + "route/richiestaVoltura/view.html",
        controller: "richiestaVolturaCtrl",
      })
      .when("/variazioneCoordinateBancarie", {
        templateUrl: context + "route/varCoordBan/view.html",
        controller: "variazioneCoordinateBanCtrl",
      })
      .when("/delegationRequest", {
        templateUrl: context + "route/delegationReq/delegationReq.html",
        controller: "delegationReqCtrl",
      })
      .when("/changeInstallationAddress", {
        templateUrl:
          context + "route/changeInstalAddress/changeInstalAddress.html",
        controller: "changeInstalAddressCtrl",
      })
      .when("/aggiornamentoDoc", {
        templateUrl: context + "route/aggiornamentoDoc/view.html",
        controller: "aggiornamentoDocCtrl",
      })
      .when("/moratorium", {
        templateUrl: context + "route/gestioneMoratoria/view.html",
        controller: "gestioneMoratoriaCtrl",
      })
      .when("/questionarioADV", {
        templateUrl: context + "route/questionarioADV/view.html",
        controller: "questionarioAdvCtrl",
      })
      .when("/assistenzaTecnica", {
        templateUrl: context + "route/assistenzaTecnica/view.html",
        controller: "assistenzaTecnicaCtrl",
      })
      .when("/calcoloIrap", {
        templateUrl: context + "route/calcoloIrap/view.html",
        controller: "calcoloIrapCtrl",
      })
      .when("/dettagliCalcolo", {
        templateUrl: context + "route/dettagliCalcolo/view.html",
        controller: "dettagliCalcoloCtrl",
      })
      .when("/riscattoAnticipato", {
        templateUrl: context + "route/riscattoAnticipato/view.html",
        controller: "riscattoAnticipatoCtrl",
      })
      .when("/informativeDocs", {
        templateUrl: context + "route/informativeDocs/view.html",
        controller: "InformativeDocsCtrl",
      })
      .when("/cambioSocContr", {
        templateUrl: context + "route/cambioSocContr/view.html",
        controller: "cambioSocContrCtrl",
      })
      .when("/lpf", {
        templateUrl: context + "route/richiestaLpf/view.html",
        controller: "richiestaLpfCtrl",
      })
      .when("/sublocazione", {
        templateUrl: context + "route/sublocazioneNoleggio/view.html",
        controller: "sublocazioneNoleggioCtrl",
      })
      .when("/aggiornamentoAdv", {
        templateUrl: context + "route/aggiornamentoAdv/view.html",
        controller: "aggiornamentoAdvCtrl",
      })
      .when("/riscattoTermine", {
        templateUrl: context + "route/riscattoTermine/view.html",
        controller: "riscattoTermineCtrl",
      })
      .when("/nuovoRespUtenza", {
        templateUrl: context + "route/nuovoRespUtenza/view.html",
        controller: "NuovoRespUtenzaCtrl",
      })
      .when("/gestioneVerbale", {
        templateUrl: context + "route/gestioneVerbale/view.html",
        controller: "GestioneVerbaleCtrl",
      })
      .otherwise({
        redirectTo: "/",
      });

    var langConfigArray = initializeLangConfig();
    for (var i = 0; i < langConfigArray.length; i++) {
      var langItemObj = langConfigArray[i];
      $translateProvider.translations(langItemObj.code, langItemObj.map);
    }
    $translateProvider.preferredLanguage("it");
    $translateProvider.useSanitizeValueStrategy("escape");
    $compileProvider.aHrefSanitizationWhitelist(
      /^\s*(https?|ftp|mailto|javascript|data):/
    );
  })

  .run(function (
    $rootScope,
    $location,
    FactoryObj,
    PermissionFactory,
    $configService,
    $menuService,
    $timeout
  ) {
    // register listener to watch route changes

    $rootScope.$on("$routeChangeStart", function (event, next, current) {
      if (next != null && next.$$route != null) {
        $rootScope.actualPath = next.$$route.originalPath;
        $rootScope.cssPageName = assignClassPageName(next.$$route.originalPath);
        console.log("cssPageName: " + $rootScope.cssPageName);

        var unauthenticatedPaths = [
          "/registerCustomer",
          "/registerVendor",
          "/login",
          "/logout",
          "/classificazioneFondiBei",
          "/questionarioADV",
        ];

        if (
          next &&
          next.$$route &&
          next.$$route.originalPath == "/login" &&
          $configService.isUserLogged() &&
          !current.$$route.originalPath == "/logout"
        ) {
          $configService.logout();
        }

        //let overlayComponent disappear
        if ($rootScope.showMessage) {
          $rootScope.showMessage = false;
        }

        //if redirecting to login from logout, force redirect to login
        if (
          next &&
          next.$$route.originalPath == "/login" &&
          current &&
          current.$$route &&
          current.$$route.originalPath == "/logout"
        ) {
          $timeout(function forceRedirect() {
            event.preventDefault();
            $rootScope.$evalAsync(function () {
              $location.path("/login");
            });
          });
        }

        //clean FactoryObj
        if (
          current != null &&
          current.$$route != null &&
          current.$$route.originalPath == "/leasingConfiguration"
        ) {
          if (FactoryObj.itemWf) {
            FactoryObj.itemWf = null;
          }
        }

        //If user is registering
        if (
          next &&
          next.$$route &&
          next.$$route.originalPath == "/" &&
          $configService.userIsRegistering() &&
          !$configService.getUser().underVerification &&
          !$configService.getUser().impersonatingNdg
        ) {
          $menuService.show();
          $menuService.openPasswordRecoveryNuArc();
        }

        //If user is logging
        if (next && next.$$route && next.$$route.originalPath == "/") {
          $menuService.show();
        }

        //check user login
        if (
          !$configService.isUserLogged() &&
          next &&
          next.$$route &&
          !unauthenticatedPaths.includes(next.$$route.originalPath)
        ) {
          $location.path("/login");
        }

        //Check whether the user has the permission to go to that page
        if (
          $rootScope.actualPath != "/login" &&
          $rootScope.actualPath != "/" &&
          !PermissionFactory.hasRoutingPermission("/" + $rootScope.cssPageName)
        ) {
          //error message, you are not authorized!
          $rootScope.$broadcast("addAlert", {
            text: "ERROR_401",
          });
          // $configService.getAppConfig() = $rootScope.initAppConfig();
          return;
        }
      }
    });
  })
  .controller(
    "AppCtrl",
    function (
      $scope,
      $location,
      $rootScope,
      $portalService,
      $configService,
      $istatService,
      $financialApiService,
      $timeout,
      $userService
    ) {
      moment.locale("it");
      $scope.rootScope = $rootScope;
      $rootScope.selectedLanguage = "it";
      $rootScope.context = context;
      $rootScope.impersonificaMap = listImpersonifica();
      if ($configService.isUserLogged()) {
        $rootScope.comuniMap = JSON.parse(localStorage.getItem('comuni'));
        $rootScope.mapComuniSoppressi = JSON.parse(localStorage.getItem('comuniNsil'));
        $rootScope.nazioniEstere = JSON.parse(localStorage.getItem('nazioni'));
        $rootScope.wizardMap = JSON.parse(localStorage.getItem('wizard'));
      }

      $rootScope.portalName = $portalService.resolveContextApplicationName(
        $rootScope.context
      );
      $rootScope.propMap = initializePropMap();
      $rootScope.isTouchDevice = false;

      var onDeviceReady = function () {
        $rootScope.cordova = window.cordova;
      };
      document.addEventListener("deviceready", onDeviceReady);
      /* $rootScope.$broadcast('enableDisableChatBox',{
        action: "HIDE"
      }); */
      if ($configService.isUserLogged()) {
        // user already logged
        if ($location.$$url === "/mycontracts" || $location.$$url === "/docArchive") {
          $location.path($location.$$url);
        } else {
          $location.path("/");
        }
        $timeout(function () {
          if ($configService.getAppConfig().envData.chatbotEnabled) {
            $rootScope.$broadcast("enableDisableChatBox", {
              action: "SHOW",
            });
          }
        }, 500);
      } else if ($location.$$url === "/classificazioneFondiBei") {
        $location.path("/classificazioneFondiBei");
      } else if ($location.$$url === "/questionarioADV") {
        $location.path("/questionarioADV");
      } else {
        // access first time
        $location.path("/login");
      }

      $rootScope.goTo = function (value) {
        $location.path(value);
      };

      $rootScope.logout = function () {


        $userService.logout()
          .then(function (response) {
            if (response.success) {

              $configService.logout();
              $rootScope.$broadcast("enableDisableChatBox", {
                action: "HIDE",
              });
            }
          })
      };

      /**
       * If DraftMode true, we come from a restore wfInstance...so take data from dynamic Content
       * and not globalPojo
       */
      $rootScope.extractMetadata = function (metadata, draftMode) {
        try {
          if (!draftMode) {
            var met = JSON.parse(metadata);
            return met.globalPojoJson;
          } else {
            var met = JSON.parse(metadata);
            return met.dynamicInputPojo;
          }
        } catch (err) {
          console.log(err.message);
          return null;
        }
      };

      $rootScope.refresh = function () {
        setTimeout(function () {
          console.log("AngularJs refresh");
          $scope.$apply();
        }, 500);
      };
      if (
        navigator.userAgent.match(
          /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i
        )
      ) {
        $rootScope.isTabletDevice = true;
      }

      $rootScope.showLoader = function (value) {
        $rootScope.loaderVisible = value;
      };

      $rootScope.is_touch_device = function () {
        $rootScope.isTouchDevice =
          "ontouchstart" in window || // works on most browsers
          navigator.maxTouchPoints; // works on IE10/11 and Surface
      };

      $rootScope.openModal = function (id) {
        $(id).modal("show");
      };

      rotationBlock();

      $rootScope.isPracticeStatus = function (selectedOrder, statusCode) {
        var status = selectedOrder.practiceStatus;
        switch (status) {
          case "15":
          case "20":
            status = 10;
            break;
          case "23":
          case "24":
            status = 25;
            break;
          default:
            break;
        }

        if (statusCode.length == 1) {
          if (statusCode == status) {
            return true;
          }
        } else {
          /* if more than 1 argument is provided, assume it's an OR operator */
          for (var i = 0; i < statusCode.length; i++) {
            if (statusCode[i] == status) {
              return true;
            }
          }
        }
        return false;
      };

      $rootScope.showPageLoader = false;
      $rootScope.$on("pageLoader", function (event, args) {
        switch (args.action) {
          case "OPEN":
            $rootScope.showPageLoader = true;
            break;

          case "CLOSE":
            $rootScope.showPageLoader = false;
            break;

          default:
            break;
        }
      });

      $rootScope.showComponentLoader = false;
      $rootScope.$on('componentLoader', function (event, args) {

        switch (args.action) {

          case "OPEN":
            $rootScope.showComponentLoader = true;
            break;

          case "CLOSE":
            $rootScope.showComponentLoader = false;
            break;

          default:
            break;
        }

      });

      $rootScope.$on("enableDisableChatBox", function (event, args) {
        switch (args.action) {
          case "SHOW":
            $scope.rootScope.showChatBot = true;
            break;

          case "HIDE":
            $scope.rootScope.showChatBot = false;
            break;

          default:
            break;
        }
        $scope.rootScope.chatBotUrl = $configService.getAppConfig().envData.chatBotUrl;
      });

      $scope.$on("$includeContentLoaded", function () {
        setTimeout(function () {
          //albaInit();
          console.log("albaInit() forced!");
        }, 300);
      });
    }
  );